import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import ElementUI from 'element-ui'
import infiniteScroll from 'vue-infinite-scroll'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/style/common.css'
import './assets/style/quill.core.css'
import './assets/style/quill.snow.css'

import * as echarts from "echarts";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import {getStudentInFo} from '@/utils/api'
import "swiper/swiper.scss";
import "swiper/css/swiper.css"
import 'babel-polyfill'
import dayjs from 'dayjs'
import Footer from './components/Footer.vue'
import tabBanner from './components/tabBanner'
Vue.component('Footer',Footer)
Vue.component('tabBanner',tabBanner)
Vue.prototype.$dayjs = dayjs
Vue.prototype.$echarts = echarts
import config from '@/utils/config'
Vue.prototype.$config = config
Vue.use(ElementUI)
Vue.use(infiniteScroll)
Vue.use(VueAwesomeSwiper)
Vue.filter('filterNum',function(value){
  return value>1000000?'100w+':value
})
// 获取学校信息
store.dispatch('getSchoolId')
// 统计访问量



// 根据token获取个人信息
if(store.state.token){
  getStudentInFo({
    id:store.state.token
  }).then(res=>{
    if(res.code=='401'){
      store.commit('set_token',"")
    }else{
      store.commit('set_user_info',res.data)
    }
   
  })
}
Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
